import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'components/base';
import useDataContext from 'data/context/data';
import contentApi from 'data/api/content';

import { FAVORITE_PRODUCTS, FAVORITE_CATEGORIES, NEW_PRODUCTS } from '../specifications/lists';

import { Head, Layout } from '../components/layout';
import HomeCarousel from '../components/custom/homeCarousel';
import {
  NewsletterSection,
  MottoSection,
  ProductsSection,
  CategoriesSection,
  ReferencesSection,
  InstagramSection,
  BlogSection,
} from '../components/custom/mainSections';

import ScriptMarkupOrganization from '../components/document/scriptMarkupOrganization';

const HomePage = props => {
  const dataContext = useDataContext();

  const favorite = useMemo(() => {
    return {
      subCategories: dataContext.getCategories(FAVORITE_PRODUCTS),
      products: dataContext.getProducts(FAVORITE_PRODUCTS),
    };
  }, [dataContext]);

  const newArrivals = useMemo(() => {
    return {
      subCategories: dataContext.getCategories(NEW_PRODUCTS),
      products: dataContext.getProducts(NEW_PRODUCTS),
    };
  }, [dataContext]);

  const favoriteCategories = dataContext.getCategories(FAVORITE_CATEGORIES);

  return (
    <>
      <Head title="Homepage" />

      <ScriptMarkupOrganization />

      <Layout>
        <HomeCarousel className="carousel-hero">
          {props.carousel.map((item, index) => (
            <HomeCarousel.Item
              key={item.key}
              index={index}
              image={item.imageKey}
              buttonLabel={item.buttonCaption}
              href={item.linkUrl}
            >
              <Typography.H2>{item.caption}</Typography.H2>
              <Typography.P className="text-light">{item.description}</Typography.P>
            </HomeCarousel.Item>
          ))}
        </HomeCarousel>

        <ProductsSection title="SHOP OUR BESTSELLERS" xs={6} md={4} {...favorite} />

        <MottoSection
          type="orange"
          label="PARABO MISSION STATEMENT"
          motto="We share in your joy, celebrate your story and help you hold onto life’s moments with thoughtfully-designed photo prints."
        />

        <CategoriesSection title="CATEGORIES" categories={favoriteCategories} xs={6} />

        <ProductsSection title="NEW ARRIVALS" xs={6} {...newArrivals} />

        <ReferencesSection />

        <InstagramSection />

        {props.blog.length > 0 && <BlogSection data={props.blog} />}

        <NewsletterSection />
      </Layout>
    </>
  );
};

HomePage.getInitialProps = async () => {
  const carousel = await contentApi.carousel();
  const blog = await contentApi.blog();

  return { carousel, blog };
};

HomePage.propTypes = {
  carousel: PropTypes.array,
  blog: PropTypes.array,
};

export default HomePage;
